import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
var GoToTier = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement(ListItem, { label: t('deviationview.tierCard.moreActionsMenu.item.goToTierPage'), onClick: function () {
            window.location.href = deviation.url;
        } }));
};
GoToTier.displayName = 'GoToTier';
export default GoToTier;
//# sourceMappingURL=GoToTier.js.map